import React from 'react';
import { OtherDetailsInner } from './styles';

const OtherDetails = ({ header, label }) => (
    <div className='d-none d-md-flex justify-content-end mt-6 pr-5'>
        <OtherDetailsInner>
            <h3 className="mb-2 text-dark">{header}</h3>
            <small className="mb-2">{label}</small>
            <small>
                <a className="text-underline" href="https://www.macu.com/loans/home-loans/meet-with-a-mortgage-loan-officer">Meet with a mortgage expert to learn more</a>
            </small>
        </OtherDetailsInner>
    </div>
);

export default OtherDetails;
